import React from 'react';
import { createComponent } from '@lit/react';

import { IxFileUploader as IxFileUploaderLit } from '../IxFileUploader.js';

customElements.define('ix-file-uploader', IxFileUploaderLit);

export const IxFileUploader = createComponent({
  tagName: 'ix-file-uploader-react',
  elementClass: IxFileUploaderLit,
  react: React,
});
